<template>
  <div class="Signature">
    <div class="actions" style="display: flex;align-items:center">
      <el-button size="mini" type="warning" @click="handleClear">清除签名</el-button>
      <el-button size="mini" type="primary" @click="handlePreview">确定签名</el-button>
      <el-button size="mini" type="info" @click="handleUndo">取消</el-button>
      <!-- <button @click="handleColor">Change Color</button> -->
    </div>
    <!-- <div class="tip">使用手机端手写更方便</div> -->
    <canvas />
  </div>
</template>

<script>
import SmoothSignature from "smooth-signature";
export default {
  name: "Signature",
  data() {
    return {
      openSmooth: true,
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      const canvas = document.querySelector("canvas");
      const options = {
        width: Math.min(window.innerWidth, 800),
        height: 600,
        minWidth: 4,
        maxWidth: 12,
        // color: '#1890ff',
        bgColor: '#f6f6f6'
      };
      this.signature = new SmoothSignature(canvas, options);
    },
    handleClear() {
      this.signature.clear();
    },
    handleUndo() {
      this.signature.undo();
      this.$emit("on-cencal");
    },
    handleColor() {
      this.signature.color = '#' + Math.random().toString(16).slice(-6);
    },
    handlePreview() {
      const isEmpty = this.signature.isEmpty();
      if (isEmpty) {
        alert('isEmpty')
        return;
      }
      const pngUrl = this.signature.getPNG();
      
      // console.log('pngUrl',pngUrl)
      this.$emit("on-pngurl",pngUrl);
      // window.previewImage(pngUrl);
    }
  },
};
</script>

<style>

.actions button {
    margin-right: 5px;
    font-size: 18px;
  }
  canvas {
    border: 2px dashed #ccc;
    cursor: crosshair;
  }
  .actions {
    margin: 10px 0;
  }
  .tip {
    color: #108eff;
  }
</style>


// WEBPACK FOOTER //
// src/components/Signature/Signature.vue